import { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';
import slugify from 'slugify';

interface Blog {
  id: string;
  blogname: string;
  author: string;
  date: string;
  status: string;
  blogcontent: string;
  eventcode?: string;
}

function Blogs() {
  const [events, setEvents] = useState<any[]>([]);
  const [blogs, setBlogs] = useState<Blog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError(null);
        
        // Fetch blogs data from API
        const response = await AxiosInstance.get('/api/getblogs');
        
        if (response.data.result === 'Success' && response.data.data) {
          // Convert object to array and filter active blogs
          const blogsArray = Object.entries(response.data.data)
            .map(([id, blog]: [string, any]) => ({
              id,
              ...blog
            }))
            .filter(blog => blog.status === 'ACTIVE')
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()); // Sort by date (newest first)
          
          setBlogs(blogsArray);
        } else {
          setBlogs([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error fetching blogs:', error);
        setError('Failed to load blogs. Please try again later.');
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  const renderBlogCard = (blog: Blog) => (
    <div className="blog-card" key={blog.id}>
      <div className="blog-card-inner">
        <div className="blog-content">
          <div className="blog-meta">
            <span className="blog-author">{blog.author}</span>
            <span className="blog-date">{formatDate(blog.date)}</span>
            {blog.eventcode && (
              <span className="blog-event">Event: {blog.eventcode}</span>
            )}
          </div>
          <h3 className="blog-title">{blog.blogname}</h3>
         {/* <div className="blog-excerpt">
            {blog.blogcontent.length > 300 
              ? `${blog.blogcontent.substring(0, 300)}...`
              : blog.blogcontent
            }
          </div>*/}
          <div className="blog-actions">
            <a href={`/blogdetails?blogid=${encodeURIComponent(blog.id)}`} className="btn btn-primary blog-read-more">Read More</a>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <style>
        {`
          .blog-card {
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 0 6px 20px rgba(0,0,0,0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
            margin-bottom: 30px;
          }
          
          .blog-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 30px rgba(0,0,0,0.15);
          }
          
          .blog-card-inner {
            padding: 25px;
          }
          
          .blog-meta {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            margin-bottom: 15px;
            font-size: 14px;
            color: #666;
          }
          
          .blog-author {
            font-weight: 600;
            color: #007bff;
          }
          
          .blog-date {
            color: #888;
          }
          
          .blog-event {
            background: #e3f2fd;
            color: #1976d2;
            padding: 2px 8px;
            border-radius: 4px;
            font-size: 12px;
          }
          
          .blog-title {
            font-size: 24px;
            font-weight: 700;
            color: #333;
            margin-bottom: 15px;
            line-height: 1.3;
          }
          
          .blog-excerpt {
            font-size: 16px;
            line-height: 1.6;
            color: #555;
            margin-bottom: 20px;
          }
          
          .blog-actions {
            display: flex;
            justify-content: flex-start;
          }
          
          .blog-read-more {
            background-color: #007bff;
            border: none;
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            transition: background-color 0.3s ease;
          }
          
          .blog-read-more:hover {
            background-color: #0056b3;
            color: white;
          }
          
          .blogs-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
            gap: 30px;
            padding: 20px 0;
          }
          
          .no-blogs {
            padding: 60px 0;
            text-align: center;
          }
          
          .no-blogs p {
            font-size: 18px;
            color: #666;
            font-style: italic;
          }
          
          .loading-spinner {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 200px;
          }
          
          .error-message {
            background: #f8d7da;
            color: #721c24;
            padding: 15px;
            border-radius: 6px;
            margin: 20px 0;
            border: 1px solid #f5c6cb;
          }
          
          @media (max-width: 768px) {
            .blog-card-inner {
              padding: 20px;
            }
            
            .blog-title {
              font-size: 20px;
            }
            
            .blog-excerpt {
              font-size: 14px;
            }
            
            .blogs-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>
      
      <div className="antialiased light-vz circle-v ">
        <Header events={events} />
        <br></br>
        <h1 className='spacer-section'></h1>

        {/* Blogs Section */}
        <section className="blogs-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="sec-title white-heading-text">
                  <span className="icon-inner wow flipInY" data-wow-duration="300ms">
                    <span className="fa-stack">
                      <i className="fa rhex fa-stack-2x"></i>
                      <i className="fa fa-newspaper-o fa-stack-1x"></i>
                    </span>
                  </span>
                  <h3 className="wow fadeInRight" data-wow-duration="500ms">
                    Latest Blogs
                    <small> / Insights and stories from our community</small>
                  </h3>
                </div>
              </div>
            </div>

            {loading ? (
              <div className="loading-spinner">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <div className="error-message">
                <i className="fa fa-exclamation-triangle"></i> {error}
              </div>
            ) : blogs.length > 0 ? (
              <div className="row">
                <div className="col-lg-12">
                  <div className="blogs-grid">
                    {blogs.map(renderBlogCard)}
                  </div>
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-lg-12">
                  <div className="no-blogs">
                    <p>No blogs available at the moment. Please check back later!</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        <MainWebFooter />
        <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
      </div>
    </>
  );
}

export default Blogs;